module.exports = __webpack_public_path__ + "da99bf0d58440d4c2174910279b9521e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/podzimni-detsky-tabor-4.jpg
// module id = 1199
// module chunks = 0